<template>
    <div id="data-list-list-view" class="data-list-container">
      <vs-button size="large" color="danger" @click="addNewData" class="flex items-center justify-center">
        <feather-icon icon="PlusIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
        <span>Send new support ticket</span>
      </vs-button>
        <ticket-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>

        <vx-card title="My tickets" class="mt-8">
            <div>
                <vs-table ref="table" v-model="selected" @change-page="handleChangePage"
                          pagination
                          sst
                          maxItems="15"
                          :total="total"
                          :data="list"
                >
                    <template slot="thead">
                        <vs-th>Code</vs-th>
                        <vs-th>Title</vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in list" @click="showData(tr)">
                            <vs-td>
                                <p class="product-name font-medium truncate">{{ tr.id }}</p>
                            </vs-td>
                            <vs-td class="flex-1">
                                <p class="product-category">{{ tr.title }}</p>
                                <div>
                                    <vs-chip color="success" class="product-order-status" v-if="tr.sender">
                                        <span>Send By: </span>
                                        {{tr.sender.name}}
                                    </vs-chip>
                                </div>
                            </vs-td>
                            <vs-td>
                                <vs-chip :color="getOrderStatusColor(tr.sts)" class="product-order-status">{{ tr.sts_str
                                    }}
                                </vs-chip>
                            </vs-td>

                            <vs-td class="whitespace-no-wrap">
                                <div>
                                    <vs-button @click="showData(tr)">Show</vs-button>
                                </div>
                            </vs-td>

                        </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import TicketSidebar from "./comp/TicketSidebar";

    export default {
        components: {
            TicketSidebar
        },
        data() {
            return {
                selected: [],
                itemsPerPage: 15,
                isMounted: false,
                addNewDataSidebar: false,
                sidebarData: {},
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            list() {
                return this.$store.state.ticket.list
            },
            total() {
                return this.$store.state.ticket.total
            }
        },
        methods: {
            addNewData() {
                this.sidebarData = {}
                this.toggleDataSidebar(true)
            },
            deleteData(id) {
                this.$store.dispatch("dataList/removeItem", id).catch(err => {
                    console.error(err)
                })
            },
            showData(data) {
                this.$store.dispatch("ticket/view", data);
                this.$router.push('tickets/show/' + data.id);
            },
            handleChangePage(page) {
                this.$store.dispatch("ticket/fetch", {page: page});
            },
            getOrderStatusColor(status) {
                if (status == 1) return "warning"
                if (status == 2) return "success"
                return "primary"
            },
            getPopularityColor(num) {
                if (num > 90) return "success"
                if (num > 70) return "primary"
                if (num >= 50) return "warning"
                if (num < 50) return "danger"
                return "primary"
            },
            toggleDataSidebar(val = false) {

                this.addNewDataSidebar = val
              this.$store.dispatch("ticket/fetch")

            }
        },
        created() {
            this.$store.dispatch("ticket/fetch")
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            right: 1rem;
                        }

                        &:focus + i {
                            right: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
